{
  "title": "Wither and Bloom",
  "source": "Strixhaven: A Curriculum of Chaos",
  "levelAndSchool": "2nd-level Necromancy",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a withered vine twisted into a loop)",
  "duration": "Instantaneous",
  "description": [
    "You invoke both death and life upon a 10-foot-radius sphere centered on a point within range. Each creature of your choice in that area must make a Constitution saving throw, taking 2d6 necrotic damage on a failed save, or half as much damage on a successful one. Nonmagical vegetation in that area withers.",
    "In addition, one creature of your choice in that area can spend and roll one of its unspent Hit Dice and regain a number of hit points equal to the roll plus your spellcasting ability modifier.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d6 for each slot above 2nd, and the number of Hit Dice that can be spent and added to the healing roll increases by one for each slot above 2nd."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
